module.exports = __webpack_public_path__ + "img/accordion_arrow.d75f58ce.svg";